import * as React from 'react';
import { Controller } from 'react-hook-form';
import TextField from '@mui/material/TextField';
import FormHelperText from '@mui/material/FormHelperText';
import { Box, Typography } from '@mui/material';

export default function FormInput({ name, control, label, rules, multiline, type, disabled, defaultValue, sx }) {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      defaultValue={ defaultValue }
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <Box sx={{ display: 'flex', gap: 12, p: 2, alignItems: 'center', ...sx }}>
          {label && (
            <Typography sx={{ p: 1, width: 256 }}>{label}</Typography>
          )}
          <TextField
            sx={{ width: 384 }}
            size='small'
            error={!!error}
            multiline={multiline ? multiline.enabled : false}
            rows={multiline ? multiline.rows : undefined}
            onChange={onChange}
            value={value || ""}
            fullWidth
            variant='outlined'
            disabled={disabled}
            type={type ? type : 'text'}
          />
          <FormHelperText sx={{ color: '#ef4444' }}>{error?.message}</FormHelperText>
        </Box>
      )}
    />
  );
}
